export enum TimeLocale {
  EnUs = 'en-US',
  EnGb = 'en-GB',
}

export interface DateFormatOptions {
  defaultDateFormat: string;
  defaultDateTimeFormat: string;
  defaultTimeFormat: string;
}

export const dateFormats: Record<TimeLocale, DateFormatOptions> = {
  [TimeLocale.EnUs]: {
    defaultDateFormat: 'MM/dd/yyyy',
    defaultDateTimeFormat: 'MM/dd/yyyy h:mm a',
    defaultTimeFormat: 'h:mm a',
  },
  // Mostly for testing purpose, but might be useful in the future
  [TimeLocale.EnGb]: {
    defaultDateFormat: 'dd/MM/yyyy',
    defaultDateTimeFormat: 'dd/MM/yyyy HH:mm',
    defaultTimeFormat: 'HH:mm',
  },
};
